import { motion } from "framer-motion";
import { Map, Users, ClipboardCheck, Activity, Monitor, Shield, MessageCircle, Gift } from "lucide-react";
import { Eyebrow, Reveal, stagger, fadeUp } from "./motion";
import { WHAT_YOU_GET } from "../config/content";

const ICONS = { Map, Users, ClipboardCheck, Activity, Monitor, Shield, MessageCircle };

export default function WhatYouGet() {
  return (
    <section id="what-you-get" className="py-16 md:py-24 bg-[#0B110D]" data-testid="what-you-get-section">
      <div className="max-w-[1180px] mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <Eyebrow>{WHAT_YOU_GET.eyebrow}</Eyebrow>
          <h2 className="font-heading uppercase text-white text-4xl sm:text-5xl leading-none tracking-wide max-w-3xl" data-testid="what-you-get-heading">
            EVERYTHING YOU NEED TO TRADE WITH <span className="text-[#22C55E]">CONFIDENCE</span>
          </h2>
        </Reveal>
        <motion.div
          variants={stagger}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-60px" }}
          className="mt-10 grid sm:grid-cols-2 lg:grid-cols-3 gap-4"
          data-testid="what-you-get-grid"
        >
          {WHAT_YOU_GET.items.map((item, i) => {
            const Icon = ICONS[item.icon] || Map;
            return (
              <motion.div
                key={item.title}
                variants={fadeUp}
                className={`card-hover rounded-2xl bg-[#0F1712] border border-[#22C55E]/[0.18] p-6 sm:p-7 ${i === 0 ? "sm:col-span-2 lg:col-span-1" : ""}`}
                data-testid={`feature-card-${i}`}
              >
                <div className="w-11 h-11 rounded-xl bg-[#22C55E]/10 border border-[#22C55E]/30 flex items-center justify-center mb-5">
                  <Icon className="w-5 h-5 text-[#22C55E]" />
                </div>
                <h3 className="font-heading uppercase text-white text-2xl tracking-wide">{item.title}</h3>
                <p className="mt-2.5 text-sm sm:text-base text-[#A7B3AA] leading-relaxed">{item.text}</p>
              </motion.div>
            );
          })}
          <motion.div
            variants={fadeUp}
            className="card-hover rounded-2xl bg-[#FACC15]/[0.06] border border-[#FACC15]/25 p-6 sm:p-7 flex items-start gap-4 sm:col-span-2"
            data-testid="bonus-strip"
          >
            <Gift className="w-6 h-6 text-[#FACC15] shrink-0 mt-1" />
            <div>
              <h3 className="font-heading uppercase text-[#FACC15] text-xl tracking-wide">Plus Bonuses</h3>
              <p className="mt-1.5 text-sm sm:text-base text-[#A7B3AA]">{WHAT_YOU_GET.bonus}</p>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
}
